import { CommonFilterModel } from "src/app/infrastructure/infrastructure-services/common/models/wrapper.model";

export class EwayBillDetails {
    SupplyType: string = '';
    SubType: number | null = null;
    DocumentType: string = '';
    TransactionType: string | number = '';
    MainHSNEntry: null | number = null;
    EWayBillNo: string = '';
    EWayBillDate: null | Date = null;
    EWayBillExpirationDate: null | Date = null;
    TransporterID: string = '';
    TransporterName: string = '';
    TransporterDocNo: string = '';
    TransporterDocDate: null = null;
    TransportationMode: null | number = null;
    Distance: number | null = null;
    VehicleType: string = '';
    VehicleNo: string = '';
    TransporterEntry: null | number = null;
    TransporterLineNumber: null = null;
    BillFromName: string = "";
    BillFromGSTIN: string = "";
    BillFromStateGSTCode: string = "";
    DispatchFromAddress1: string = "";
    DispatchFromAddress2: string = "";
    DispatchFromZipCode: string = "";
    DispatchFromStateGSTCode: string = "";
    BillToName: string = "";
    BillToGSTIN: string = "";
    BillToStateGSTCode: string = "";
    ShipToAddress1: string = "";
    ShipToAddress2: string = "";
    ShipToZipCode: string = "";
    ShipToStateGSTCode: string = "";
    DispatchFromPlace: string = "";
    ShipToPlace: string = "";

    U_UTL_CARES: string = "";
    U_UTL_ST_CANRMK: string = "";
    U_UTL_ST_UPRESR: string = "";
    U_UTL_ST_URMK: string = "";
    U_UTL_ST_EWayUpDt: string = "";
    U_UTL_ST_EWBSts: string = "";
}
export class EwayBillDetailsInven {
    U_UTL_ST_DocEnt: string = '';
    U_UTL_ST_BSobjTyp: string = '';
    U_UTL_ST_SuplyType: string = '';
    U_UTL_ST_SubSplyTyp: string = '';
    U_UTL_ST_DocType: string = '';
    U_UTL_ST_TransTyp: string | number = '';
    U_UTL_ST_MainHsnEnt: number | null = null;
    U_UTL_ST_EwayBillNo: string = '';
    U_UTL_ST_EwbDate: null | Date = null;
    U_UTL_ST_ExpireDate: null | Date = null;
    U_UTL_ST_TransCode: string = '';
    U_UTL_ST_TransID: string = '';
    U_UTL_ST_TransName: string = '';
    U_UTL_ST_TransDocNo: string = '';
    U_UTL_ST_TransDate: null = null;
    U_UTL_ST_TransMode: null | string = null;
    U_UTL_ST_Distance: number | null = null;
    U_UTL_ST_VehicleTyp: string = '';
    U_UTL_ST_VehicleNo: string = '';
    U_UTL_ST_FrmTraName: string = '';
    U_UTL_ST_FrmGSTN: string = '';
    U_UTL_ST_FrmAdd1: string = '';
    U_UTL_ST_FrmAdd2: string = '';
    U_UTL_ST_FrmZipCode: string = '';
    U_UTL_ST_ToTraName: string = '';
    U_UTL_ST_ToGSTN: string = '';
    U_UTL_ST_ToAdd1: string = '';
    U_UTL_ST_ToAdd2: string = '';
    U_UTL_ST_ToZipCode: string = '';
    U_UTL_ST_FrmPlace: string = '';
    U_UTL_ST_ToPlace: string = '';
    U_UTL_ST_ActToState: string = '';
    U_UTL_ST_FrmState: string = '';
    U_UTL_ST_CARES: string = '';
    U_UTL_ST_CANRMK: string = '';
    U_UTL_ST_UPRESR: string = '';
    U_UTL_ST_URMK: string = '';
    U_UTL_ST_CANDT: null | Date = null;
    U_UTL_ST_UPDT: null | Date = null;
}

export class EInvoiceModel {
  companyDB: string = '';
  password: string = '';
  userName: string = '';
  dbInstance: string = '';
  serviceLayerUrl: string = '';
  _DocEntry: string = '';
  _ObjectType: string = '';
  _DBConnection: string = '';
  databaseServerType: string = '';
  apiGateWayUrl: string = '';
  layoutName: string = '';
  layoutId: string = '';
  actionName: string = '';
  documentCode: string = '';
  irn: string = '';
  ReturnDataQueryURL: string = '';
  U_UTL_ST_ESTATUS: string = '';
  U_UTL_ST_EWBSts: string = '';
  eWayBillNo: string = '';
  StockTransferEwayDocEntry: number | null = 0;
}

export class ElectronicProtocol {
    ProtocolCode: string = ''
    GenerationType: string = ''
    MappingID: number = 0
}

export class EWayDataModel {
  listOfFilter: CommonFilterModel[] = new Array();
  // listOfMultiSelectFilters: CommonMultiFilterModel[] = new Array();
  sortBy: string = '';
  sortOrder: string = '';
  pageIndex: number = 0;
  pageSize: number = 0;
  userType: string = '';
  fyGuid: string = '';
  userContactGuid: string = '';
  customerGuid: string = '';
  serviceGuId: string = '';
  createDate: string = '2024-01-22T11:19:14.529Z';
  companyGuId: string = '';
  accountGuId: string = '';
  searchValue: string = '';
}

export class TransporterModel {
    "#": number = 1;
    TransporterCode: string = '';
    TransporterName: string = '';
    TransporterId: string = '';
    TransporterEntry: string = '';
    TransporterLineNumber: string = '';
    Mode: string = '';
    VehicleType: string = '';
    VehicleNo: string = '';
}

export class MainHsnModel {
    "#": number = 1;
    Chapter: string = '';
    Heading: string = '';
    SubHeading: string = '';
    Description: string = '';
}

export class StateModel {
    "#": number = 1;
    Code: string = '';
    Name: string = '';
    Country: string = '';
    CountryName: string = '';
    GSTCode: string = '';
}

export class GetEInvoiceModel {
  U_UTL_QRPT: string = '';
  U_UTL_IRN: string = '';
  U_UTL_IST: string = '';
  U_UTL_RMK: string = '';
  U_UTL_CANDT: string = '';
  U_UTL_IRNGENDT: string = '';
}

